<div class="d-flex justify-content-center align-items-center gap-2 p-5">
  <app-spinner />
  <div>Loading, please wait...</div>
</div>
